module.exports = __webpack_public_path__ + "static/media/ico_tint_mid_sel.986c4d53.svg";